// App.tsx
import { Canvas, useThree } from "@react-three/fiber";
import { useProgress } from "@react-three/drei";
import { Suspense, useState, useEffect } from "react";

export function SceneReady({ onReady }: { onReady: () => void }) {
    const { gl } = useThree();

    useEffect(() => {
        // Wait for first frame to render
        const timer = setTimeout(() => {
            onReady();
        }, 100); // Small delay to ensure render

        return () => clearTimeout(timer);
    }, [onReady]);

    return null;
}

export function LoadingOverlay({ isReady }: { isReady: boolean }) {
    const { progress } = useProgress();
    const [displayProgress, setDisplayProgress] = useState(0.0);
    const [shouldHide, setShouldHide] = useState(false);
    const [shouldBeInvisible, setShouldBeInvisible] = useState(false);

    useEffect(() => {
        if (progress > displayProgress) setDisplayProgress(progress);
    }, [displayProgress, progress]);

    useEffect(() => {
        if (displayProgress === 100 && isReady) {
            setShouldHide(true);
            const timer = setTimeout(() => {
                setShouldBeInvisible(true);
            }, 800);
            return () => clearTimeout(timer);
        }
    }, [displayProgress, isReady]);

    return (
        <div
            style={{
                position: "fixed",
                inset: 0,
                zIndex: 1000,
                // background: 'linear-gradient(to bottom, #4663ca, #4a84bf, #60b1bf)',
                background: "black",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "row",
                transition: "opacity 0.5s ease-out 0.3s",
                opacity: shouldHide ? 0 : 1,
                pointerEvents: shouldHide ? "none" : "all",
                visibility: shouldBeInvisible ? "hidden" : "visible",
                gap: "-0.5rem",
            }}
        >
            {/* <h1 style={{ color: '#fff', marginBottom: '20px' }}>{shouldHide ? 'Loading ✓' : 'Loading...'}</h1> */}
            <div
                style={{
                    width: "1.0rem",
                    height: "2.5rem",
                    border: "0.25rem solid white",
                    borderRight: "none",
                    transform: "translate(calc(1.0rem - 0.25rem))",
                }}
            />
            <div
                style={{
                    width: "25%",
                    height: "2rem",
                    background: "rgba(255, 255, 255, 0.2)",
                    borderRadius: "0",
                    overflow: "hidden",
                }}
            >
                <div
                    style={{
                        width: `${displayProgress}%`,
                        height: "100%",
                        background: "#fff",
                        transition: "width 1.0s ease-out",
                    }}
                />
            </div>
            <div
                style={{
                    width: "1.0rem",
                    height: "2.3rem",
                    border: "0.25rem solid white",
                    borderLeft: "none",
                    transform: "translate(calc(-1 * (1.0rem - 0.25rem)))",
                }}
            />
        </div>
    );
}
